'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './users.routes';

export class UsersComponent {
  /*@ngInject*/
  constructor($http, $scope, $timeout, $location,landuse, lookup, db) {
    // Define Services
    this.$http = $http;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$location = $location;
    this.landuse = landuse;
    this.lookup = lookup;
    this.db = db;
  }

  $onInit() {
    this.loadUsers();
    this.$scope.counties = this.lookup.getCounties();
  }

  loadUsers() {
    this.$http.get('/api/users/getUsers')
      .then(response => {
        console.log(response);
        this.$scope.users = response.data;
        this.$scope.rowCollection = response.data;
        this.getJurisdictions();

        //Refresh multi select inputs in case data hasn't yet loaded
        setTimeout(function () {
          $('.selectpicker').selectpicker('refresh'); // refresh the selectpicker with fetched courses
        }, 1000);
      })
      .catch(err => {
        console.log(err);
      });
  }

  getJurisdictions() {
    this.$http.get('/api/data/admin/lookup/jurisdictions')
      .then(response => {
        console.log(response.data);
        this.$scope.jurisdictions = response.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  getRoleJurisdictions() {
    console.log(this.updateUsersDataset);
    if(this.updateUsersDataset.Jurisdictions){
      delete this.updateUsersDataset.Jurisdictions;
    }

    console.log(this.updateUsersDataset);
    this.$http.get('/api/data/admin/lookup/role/jurisdictions/' + this.updateUsersDataset._id)
      .then(response => {
        console.log(response.data);
        // this.$scope.jurisdictions = response.data;
        if(response.data[0]) {
          this.updateUsersDataset.Jurisdictions = response.data[0].jurisdiction.split(',');
          console.log(this.updateUsersDataset.Jurisdictions);
          setTimeout(function () {
            $('.selectpicker').selectpicker('refresh'); // refresh the selectpicker with fetched courses
          }, 500);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  /**
     * @desc Opens appropriate update modal window based on parameters
     * @param {string} type - data type being edited. Either Users or Contacts
     * @param {object} data - data loaded from value selected in the table
     */
  updateModal(data) {
    console.log(data);
    // this.$scope.test = ["Alameda","San Francisco"];
    setTimeout(function () {
      $('.selectpicker').selectpicker('refresh'); // refresh the selectpicker with fetched courses
    }, 1000);

    var type = this.Type;

    this.updateUsersDataset = data;
    if (data.basis_app && data.basis_app === 1) {
      this.updateUsersDataset.basis_app = true;
    } else {
      this.updateUsersDataset.basis_app = false;
    }

    if (data.hess_app && data.hess_app === 1) {
      this.updateUsersDataset.hess_app = true;
    } else {
      this.updateUsersDataset.hess_app = false;
    }

    this.getRoleJurisdictions();

    $('#updateUsersModal').modal();

    this.dataset = data;
    console.log(this.dataset);
  }

  /**
     * @desc Posts form data from users or contacts modal to update item in database
     * @param {string} form - form being submitted
     */
  updateUser(form) {
    console.log(form);
    var updateUser, url;
    var type = this.Type;
    var updateId;

    updateUser = this.updateUsersDataset;
    updateId = this.updateUsersDataset._id;
    url = '/api/users/' + updateId + '/user';


    console.log(url);
    console.log(updateUser);

    this.$http.put(url, updateUser)
      .then(response => {
        console.log(response);
        //reload the table
        this.loadUsers(type);
        //Close modal window
        $('#updateUsersModal').modal('hide');
        $('#updateContactsModal').modal('hide');
      })
      .catch(err => {
        console.log(err);
      });
  }
}

export default angular.module('hessApplicationApp.users', [uiRouter])
  .config(routes)
  .component('users', {
    template: require('./users.html'),
    controller: UsersComponent,
    controllerAs: 'usersCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/users/users.component.js